import { DocumentCategory, DocumentCategoryNormalized } from '../../api/models/documents.models';

export const getNormalizedDocumentCategories = (
  flatCategories: DocumentCategory[]
): {
  categories: DocumentCategoryNormalized[];
  categoryMap: Record<string, DocumentCategoryNormalized>;
} => {
  const categories: DocumentCategoryNormalized[] = [];
  const categoryMap: Record<string, DocumentCategoryNormalized> = {};

  flatCategories.forEach((category) => {
    const normalizedCategory: DocumentCategoryNormalized = {
      ...category,
      ChildDocumentCategoryIds: [],
      Level: 0,
      IsExpanded: false,
      DocumentHeaderIds: [],
      HasLoadedDocumentHeaders: false,
    };

    categories.push(normalizedCategory);
    categoryMap[category.DocumentCategoryId] = normalizedCategory;
  });

  // Calculate parent/child relationships and set level
  categories.forEach((category) => {
    if (category.ParentDocumentCategoryId) {
      const parent = categoryMap[category.ParentDocumentCategoryId];
      if (parent) {
        category.Level = parent.Level + 1;
        parent.ChildDocumentCategoryIds.push(category.DocumentCategoryId);
      }
    }
  });

  // Sort by level and sequence
  categories.sort((a, b) => {
    if (a.Level !== b.Level) return a.Level - b.Level;
    return (a.DocumentCategorySequence || 0) - (b.DocumentCategorySequence || 0);
  });

  return { categories, categoryMap };
};
